import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {ContractItem} from '../models/contract-item';
import {
  ChangeContractsPageSizeAction,
  contractListActionTypes,
  LoadContractsSuccessAction,
  OrderContractsByAction,
  PageContractsToAction,
  QuickSearchContractsAction,
  SearchContractsAction,
  ToggleSearchContractsAction
} from '../actions/contracts-list';
import {ContractFilter} from '../models/contract-filter';

export interface ContractsState {
  array: ContractItem[];
  showFilter: boolean;
  quickSearch: string;
  filter: ContractFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
}

const initialState: ContractsState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0
};

export function ContractsListReducer(state: ContractsState = initialState, action: Action): ContractsState {
  switch (action.type) {

    case contractListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case contractListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case contractListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case contractListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case contractListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case contractListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case contractListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case contractListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case contractListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: ContractsState, action: ToggleSearchContractsAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    showFilter: action.payload
  };
  return newState;
}

function handleQuickSearchAction(state: ContractsState, action: QuickSearchContractsAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    quickSearch: action.payload,
    page: 1
  };
  return newState;
}

function handleSearchAction(state: ContractsState, action: SearchContractsAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    filter: action.payload,
    page: 1
  };
  return newState;
}

function handlePageToAction(state: ContractsState, action: PageContractsToAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    page: action.payload
  };
  return newState;
}

function handleLoadSuccessAction(state: ContractsState, action: LoadContractsSuccessAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}


function handleChangePageSizeAction(state: ContractsState, action: ChangeContractsPageSizeAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    page: 1,
    pageSize: action.payload
  };
  return newState;
}
function handleOrderByAction(state: ContractsState, action: OrderContractsByAction): ContractsState {
  const newState: ContractsState = {
    ... state,
    orderBy: action.payload
  };
  return newState;
}

function handleLoadClearActions(): ContractsState {
  const newState: ContractsState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0
  };
  return newState;
}

function handleLoadErrorActions(state: ContractsState): ContractsState {
  return state;
}


export const contractsListSelectors = {
  showFilter: (state: ContractsState) => _.get(state, 'showFilter', false),
  quickSearch: (state: ContractsState) => _.get(state, 'quickSearch'),
  filter: (state: ContractsState) => _.get(state, 'filter'),
  page: (state: ContractsState) => _.get(state, 'page', 1),
  pageSize: (state: ContractsState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: ContractsState) => _.get(state, 'orderBy'),
  array: (state: ContractsState) => _.get(state, 'array', []),
  count: (state: ContractsState) => _.get(state, 'count', 0),
};
